import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { InventorySettings, LotCostingMethod } from '../interfaces/inventory/inventorySettings.interface';

/** G6a: inventory costing settings (read STOCK_VIEW, switch INVENTORY_SETTINGS_MANAGE). */
export const InventorySettingsService = {
  get: async (institutionId: string): Promise<InventorySettings> =>
    (await axios.get(ENDPOINTS.INVENTORY_SETTINGS.GET(institutionId))).data,
  switchMethod: async (institutionId: string, lotCostingMethod: LotCostingMethod): Promise<InventorySettings> =>
    (await axios.put(ENDPOINTS.INVENTORY_SETTINGS.LOT_COSTING_METHOD(institutionId), { lotCostingMethod })).data,
};
